/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformAddUserAccount } from '../../models/platform-add-user-account';
import { PlatformApiResultOfUserGroupDto } from '../../models/platform-api-result-of-user-group-dto';

export interface PostUsergroupsActionAdduseraccount$Params {
      body: PlatformAddUserAccount
}

export function postUsergroupsActionAdduseraccount(http: HttpClient, rootUrl: string, params: PostUsergroupsActionAdduseraccount$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
  const rb = new RequestBuilder(rootUrl, postUsergroupsActionAdduseraccount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserGroupDto>;
    })
  );
}

postUsergroupsActionAdduseraccount.PATH = '/api/usergroups/action/adduseraccount';
